interface IdBadgeProps {
	id: number
	boxNumber?: string
}

const IdBadge: React.FC<IdBadgeProps> = ({ id, boxNumber }) => {
	if (!boxNumber) {
		return (
			<div className="inline-flex items-center rounded-md border border-border bg-shade text-muted-foreground text-sm font-medium px-2 py-1 h-6">
				<span>ID: {id}</span>
			</div>
		)
	}

	return (
		<div className="inline-flex items-center rounded-md border border-border bg-shade text-muted-foreground text-sm font-medium h-6 px-2 py-1 h-6">
			<span className="pr-2 mr-2 border-r-1">ID: {id}</span>
			<span>{boxNumber}</span>
		</div>
	)
}

export default IdBadge
